import { IPNNVControlState, IPNNVState } from './pnnv.types'
import { PNNVConstants } from './pnnv.constants'
import { IPNNVOption } from '../../../common/common.types'

const defaultStateForController: IPNNVControlState = {
  isOpen: false,
  options: [],
  currentPNNVValue: null,
  onPNNVChangeHandler: (option: IPNNVOption, dispatchData?: any) => null,
  pnnvLabel: '',
  pnnvListHeader: '',
  nemsis: '',
  customEvent: null,
}
export const initialPNNVState: IPNNVState = {
  numberPadAndCalendar: defaultStateForController,
  freeTextField: {
    ...defaultStateForController,
    showConfirmation: false,
    nonPNNVDataResetFunction: () => null,
    showPWAPNNVBar: false,
  },
  preventResetIdentifiers: [],
}

export function pnnvReducer(state: IPNNVState = initialPNNVState, action: any): IPNNVState {
  switch (action.type) {
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_IS_OPEN:
      return { ...state, numberPadAndCalendar: { ...state.numberPadAndCalendar, isOpen: action.isOpen } }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_OPTIONS:
      return { ...state, numberPadAndCalendar: { ...state.numberPadAndCalendar, options: action.options } }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_CURRENT_PNNV_VALUE:
      return {
        ...state,
        numberPadAndCalendar: { ...state.numberPadAndCalendar, currentPNNVValue: action.currentPNNVValue },
      }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_PNNV_CHANGE_HANDLER:
      return {
        ...state,
        numberPadAndCalendar: { ...state.numberPadAndCalendar, onPNNVChangeHandler: action.onPNNVChangeHandler },
      }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_PNNV_LABEL:
      return { ...state, numberPadAndCalendar: { ...state.numberPadAndCalendar, pnnvLabel: action.pnnvLabel } }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_PNNV_LIST_HEADER:
      return {
        ...state,
        numberPadAndCalendar: { ...state.numberPadAndCalendar, pnnvListHeader: action.pnnvListHeader },
      }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_CUSTOM_EVENT:
      return {
        ...state,
        numberPadAndCalendar: { ...state.numberPadAndCalendar, customEvent: action.customEvent },
      }
    case PNNVConstants.SET_NUMBERPAD_CALENDAR_NEMSIS:
      return { ...state, numberPadAndCalendar: { ...state.numberPadAndCalendar, nemsis: action.nemsis } }

    case PNNVConstants.SET_FREE_TEXT_IS_OPEN:
      return { ...state, freeTextField: { ...state.freeTextField, isOpen: action.isOpen } }
    case PNNVConstants.SET_FREE_TEXT_SHOW_PWA_PNNV_BAR:
      return { ...state, freeTextField: { ...state.freeTextField, showPWAPNNVBar: action.showPWAPNNVBar } }
    case PNNVConstants.SET_FREE_TEXT_OPTIONS:
      return { ...state, freeTextField: { ...state.freeTextField, options: action.options } }
    case PNNVConstants.SET_FREE_TEXT_CURRENT_PNNV_VALUE:
      return { ...state, freeTextField: { ...state.freeTextField, currentPNNVValue: action.currentPNNVValue } }
    case PNNVConstants.SET_FREE_TEXT_PNNV_CHANGE_HANDLER:
      return { ...state, freeTextField: { ...state.freeTextField, onPNNVChangeHandler: action.onPNNVChangeHandler } }
    case PNNVConstants.SET_FREE_TEXT_PNNV_LABEL:
      return { ...state, freeTextField: { ...state.freeTextField, pnnvLabel: action.pnnvLabel } }
    case PNNVConstants.SET_FREE_TEXT_PNNV_LIST_HEADER:
      return { ...state, freeTextField: { ...state.freeTextField, pnnvListHeader: action.pnnvListHeader } }
    case PNNVConstants.SET_FREE_TEXT_CUSTOM_EVENT:
      return { ...state, freeTextField: { ...state.freeTextField, customEvent: action.customEvent } }
    case PNNVConstants.SET_FREE_TEXT_SHOW_CONFIRMATION:
      return { ...state, freeTextField: { ...state.freeTextField, showConfirmation: action.showConfirmation } }

    case PNNVConstants.SET_FREE_TEXT_NON_PNNV_DATA_RESET:
      return {
        ...state,
        freeTextField: { ...state.freeTextField, nonPNNVDataResetFunction: action.nonPNNVDataResetFunction },
      }
    case PNNVConstants.SET_PNNV_STATE_VALUES:
      return {
        ...state,
        freeTextField: {
          ...state.freeTextField,
          customEvent: action.freeTextField?.customEvent,
          pnnvListHeader: action.freeTextField?.pnnvListHeader,
          pnnvLabel: action.freeTextField?.pnnvLabel,
          onPNNVChangeHandler: action.freeTextField?.pnnvAction,
          currentPNNVValue: action.freeTextField?.pnnvValue,
          options: action.freeTextField?.pnnvOptions,
          showPWAPNNVBar: action.freeTextField?.showPWAPNNVBar,
          isOpen: action.freeTextField?.isOpen,
          nemsis: action.freeTextField?.nemsis,
        },
      }
    case PNNVConstants.SET_FREE_TEXT_NEMSIS:
      return { ...state, freeTextField: { ...state.freeTextField, nemsis: action.nemsis } }
    case PNNVConstants.PREVENT_RESET_PNNV_VALUE:
      return { ...state, preventResetIdentifiers: action.preventResetIdentifiers }
    case PNNVConstants.RESET_STATE:
      return { ...initialPNNVState }
    default:
      return state
  }
}
